'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = modelExtend;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modelExtend() {
  var base = {
    state: {},
    subscriptions: {},
    effects: {},
    reducers: {}
  };

  for (var _len = arguments.length, models = Array(_len), _key = 0; _key < _len; _key++) {
    models[_key] = arguments[_key];
  }

  return models.reduce(function (acc, extend) {
    acc.namespace = extend.namespace;
    if ((0, _typeof3.default)(extend.state) === 'object' && !Array.isArray(extend.state)) {
      (0, _assign2.default)(acc.state, extend.state);
    } else if ('state' in extend) {
      acc.state = extend.state;
    }
    (0, _assign2.default)(acc.subscriptions, extend.subscriptions);
    (0, _assign2.default)(acc.effects, extend.effects);
    (0, _assign2.default)(acc.reducers, extend.reducers);
    return acc;
  }, base);
};